type Params = {
  [key: string]: any;
};

const AccountQueryKeys = {
  global: ["accounts"] as const,

  /**
   * Lists
   */
  mutes: () => [...AccountQueryKeys.global, "mutes"] as const,
  blocks: () => [...AccountQueryKeys.global, "blocks"] as const,

  /** Used to fetching a single Account */
  account: (accountId: string) =>
    [...AccountQueryKeys.global, accountId] as const,
  followers: (accountId: string) =>
    [...AccountQueryKeys.account(accountId), "followers"] as const,
  following: (accountId: string) =>
    [...AccountQueryKeys.account(accountId), "following"] as const,
  connections: (accountId: string, params: Params) =>
    [...AccountQueryKeys.account(accountId), "connections", params] as const,

  /**
   * Lookup
   */
  accountByUsername: (username: string) =>
    [
      ...AccountQueryKeys.global,
      "lookup",
      "username",
      username?.toLowerCase(),
    ] as const,

  /**
   * Reactions
   */
  fromReactions: (statusId: string) =>
    [
      ...AccountQueryKeys.global,
      "reactions",
      "status",
      statusId,
      "accounts",
    ] as const,

  /**
   * From Statuses
   */
  statusFavourites: (statusId: string) =>
    [...AccountQueryKeys.global, "status", statusId, "favourites"] as const,
  reblogs: (statusId: string) =>
    [...AccountQueryKeys.global, "reblogs", statusId] as const,

  /**
   * From groups
   */
  groupBlocks: (groupId: string) =>
    [...AccountQueryKeys.global, "group", groupId, "blocks"] as const,
  groupMembershipRequests: (groupId: string) =>
    [
      ...AccountQueryKeys.global,
      "group",
      groupId,
      "membershipRequests",
    ] as const,

  /**
   * From search
   */
  search: (q: string) => [...AccountQueryKeys.global, "search", q] as const,
};

export { AccountQueryKeys };
